<template>
  <img
    :src="src"
    @touchstart="touchstart"
    @touchend="touchend"
  />
</template>
<script>
import { BUTTON_CLICK } from "../utils/bigDataSdk";

const pageInfo = {
  pageId: "40004",
  pageName: "导购企微二维码页",
  pageTilte: "报名成功",
};

export default {
  data: () => {
    return {};
  },
  props: {
    tracker: Function,
    src: String,
    meta: Object,
  },
  methods: {
    touchstart() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.longPress();
      }, 300);
    },
    touchend() {
      clearTimeout(this.timer);
    },
    // 长按统计
    longPress() {
      this.tracker({
        eventKey: BUTTON_CLICK,
        ...pageInfo,
        ...meta,
      });
    },
  },
};
</script>
 
